import React, { useEffect, useState } from "react";

import { ACTIVITY_CONTEXT } from "Constants/constants";
import EnvironmentBackupModal from "Containers/NavBar/Environment/BackupModal";
import Loading from "ds/PageLoading";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  getSelectors,
  loadEnvironmentActivities,
  selectBackupActivities
} from "Reducers/activity";
import { loadEnvironment, environmentSelector } from "Reducers/environment";
import { gitProjectSelector } from "Reducers/project/project";
import ActivityList from "src/organization/common/components/ActivityList";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { NoBackupsIllustration } from "./Backups";
import * as S from "./Backups.styles";

type BackupsHistoryProps = {
  projectId: string;
  environmentId: string;
  organizationId: string;
};

const BackupsHistory = ({
  environmentId,
  organizationId,
  projectId
}: BackupsHistoryProps) => {
  const dispatch = useAppDispatch();

  const [openModal, setOpenModal] = useState(false);

  const project = useSelectorWithUrlParams(gitProjectSelector);
  const environment = useSelectorWithUrlParams(environmentSelector);
  const { isLoading } = getSelectors("environment", {
    projectId,
    organizationId,
    environmentId
  });
  const isLoadingActivities = useAppSelector(isLoading);
  const activities = useAppSelector(state =>
    selectBackupActivities(state, {
      projectId,
      organizationId,
      environmentId
    })
  );

  const loadActivity = () => {
    dispatch(
      loadEnvironmentActivities({
        projectDescriptionId: projectId,
        environmentDescriptionId: environmentId,
        organizationDescriptionId: organizationId,
        context: ACTIVITY_CONTEXT.Environment,
        filterNames: ["backup"]
      })
    );
  };

  useEffect(loadActivity, [dispatch, environmentId, organizationId, projectId]);
  useEffect(() => {
    if (!environment)
      dispatch(loadEnvironment({ organizationId, projectId, environmentId }));
  }, [dispatch, environment, environmentId, organizationId, projectId]);

  return (
    <>
      {isLoadingActivities ? (
        <Loading />
      ) : (
        <S.List>
          {activities.length === 0 ? (
            <NoBackupsIllustration onClick={() => setOpenModal(true)} />
          ) : (
            <ActivityList
              organizationId={organizationId}
              activities={activities}
              activityType="all"
              activityIsLoading={isLoadingActivities}
              canEditProject={
                project &&
                typeof project.hasPermission === "function" &&
                project.hasPermission("#edit")
              }
            />
          )}
        </S.List>
      )}

      <EnvironmentBackupModal
        isOpen={openModal}
        closeModal={() => setOpenModal(false)}
      />
    </>
  );
};

export default BackupsHistory;
